import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import * as moment from 'moment';
import { Moment } from 'moment';
import { PageBase } from 't4core';
import { CampaignInfo } from '../../../../../projects/t4core/src/public-api';
import { T4DatatableWidget } from '../../../../t4common';


interface campaingGroup {
  status: string;
  campaignInfoList: CampaignInfo[];
}

interface CampaignData{
  Title: string;
  DiscountCode: string;
  FromDate: Date;
  ToDate: Date;
  Sent: number;
  Used: number;
}

@Component({
  styleUrls: ['./partnerDashboard.css'],
  selector: 'partnerDashboard',
  templateUrl: './partnerDashboard.html',
})
export class PartnerDashboard extends PageBase implements OnInit {
  private _fromDate: Moment = moment().startOf('month');
  private _toDate: Moment = moment().endOf('month');

  public get fromDate(): Moment { return this._fromDate; }
  public set fromDate(value: Moment) { this._fromDate = value; }

  public get toDate(): Moment { return this._toDate; }
  public set toDate(value: Moment) { this._toDate = value; }


  @ViewChild("tblActive", { static: false }) private tblActive: T4DatatableWidget;
  @ViewChild("tblArchived", { static: false }) private tblArchived: T4DatatableWidget;

  public activePartnerCampaigns: CampaignInfo[];
  public archivedPartnerCampaigns: CampaignInfo[];
  public selectedCampaign: CampaignInfo | null = null;
  public campaignInfoGroups: campaingGroup[];

  public selectedCampaignData: CampaignData;
  public campaignData: CampaignData[];

  public activeCampaignData: CampaignData[] =[];
  public archivedCampaignData: CampaignData[]= [];


  public loading: boolean = false;
  public campaognInfoControl = new FormControl('');

  constructor(el: ElementRef) {
    super(el, "Campaigns");
  }

  public async ngOnInit() {
    this.loading = true;
    this.activePartnerCampaigns = await this.Api.get<CampaignInfo[]>("/Campaign/GetActivePartnerCampaigns");
    this.archivedPartnerCampaigns = await this.Api.get<CampaignInfo[]>("/Campaign/GetArchivedPartnerCampaigns");

    this.campaignData = await this.Api.get<CampaignData[]>("/Campaign/GetPartnerCampaignData");

    var currentDate = new Date();

    this.campaignData.forEach(campaign => {
      if (campaign.ToDate < currentDate) {
        this.archivedCampaignData.push(campaign);
      } else {
        this.activeCampaignData.push(campaign);
      }
    });

    this.tblActive.update();
    this.tblArchived.update();

    console.log(this.activeCampaignData);
    console.log(this.archivedCampaignData);

    this.groupCampaigns();
    

    this.loading = false;
  }



  private groupCampaigns() {
    this.campaignInfoGroups = [
      {
        status: 'Active',
        campaignInfoList: this.activePartnerCampaigns
      },
      {
        status: 'Archived',
        campaignInfoList: this.archivedPartnerCampaigns
      }
    ];
  }

  public async onCampaignChange(campaign: CampaignInfo) {
    this.loading = true;
    this.selectedCampaign = campaign;

    this.selectedCampaignData = await this.Api.get<any>("/Campaign/GetPartnerCampaignData", { discountCode: this.selectedCampaign.DiscountCode });

    console.log(this.selectedCampaignData);
    console.log(this.campaignData);

    this.loading = false;
  }


  public async loadData() {
    //Trigger ngOnChanges on child components
    this.fromDate = this.fromDate.clone();
  }

  public onClear(event) {
    this.selectedCampaign = null;
    event.stopPropagation();

  }

}


